console.log('Audio-Button Script geladen');

document.addEventListener('DOMContentLoaded', function() {
  const audioButtons = document.querySelectorAll('.audio-load-btn');
  console.log('Buttons gefunden:', audioButtons.length);
  
  audioButtons.forEach(function(button, index) {
    button.addEventListener('click', function() {
      const sku = this.dataset.sku;
      const vendor = this.dataset.vendor;
      const product = this.dataset.product;
      const productType = this.dataset.type;
      
      console.log('Lade Audio:', product, 'von', vendor);
      
      const playerContainer = document.querySelector('.player-container');
      
      if (playerContainer) {
        // Bestehende iframes entfernen
        const existingIframes = playerContainer.querySelectorAll('iframe');
        existingIframes.forEach(function(iframe) {
          iframe.remove();
        });
        
        // Audio URL erstellen (mit korrektem Produkttyp)
        let audioUrl = 'https://geerdes.media/apps/demos/?a=' + sku;
        let height = '100px';
        
        if (productType === 'Midifile' || productType === 'Pro-Midifile' || productType === 'ProV-Midifile') {
          audioUrl += '&o=0';
        } else if (productType === 'Playback') {
          audioUrl += '&o=1';
        } else if (productType === 'Pro-Playback') {
          audioUrl += '&o=2';
        } else if (productType === 'ProV-Playback') {
          audioUrl += '&o=3';
          height = '150px';
        } else {
          audioUrl += '&o=0';
        }
        
        audioUrl += '&iframe&download&color=424548,424548';
        
        // Neues iframe erstellen
        const newIframe = document.createElement('iframe');
        newIframe.src = audioUrl;
        newIframe.style.border = '0';
        newIframe.style.overflowY = 'hidden';
        newIframe.style.width = '100%';
        newIframe.style.height = height;
        newIframe.scrolling = 'no';
        
        playerContainer.appendChild(newIframe);
        
        // Track-Info aktualisieren
        const trackInfo = document.querySelector('.track-info');
        if (trackInfo) {
          // Titel aktualisieren
          const trackTitleSpans = trackInfo.querySelectorAll('span');
          console.log('Gefundene spans:', trackTitleSpans.length);
          
          trackTitleSpans.forEach(function(span, index) {
            console.log('Span', index, ':', span.textContent);
          });
          
          // Ersten span (Titel) aktualisieren
          if (trackTitleSpans.length > 1) {
            trackTitleSpans[1].textContent = product;
            console.log('Titel gesetzt:', product);
          }
          
          // Letzten span (Vendor) aktualisieren  
          if (trackTitleSpans.length > 3) {
            trackTitleSpans[3].textContent = vendor;
            console.log('Vendor gesetzt:', vendor);
          }
        }
        
        console.log('Audio geladen:', product, 'von', vendor);
      }
    });
  });
});
